// extracted by mini-css-extract-plugin
export default {"icon":"ProposalFlag_icon__IAW69","proposalFlagOverlay":"ProposalFlag_proposalFlagOverlay__pH4cD"};